<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 class="headline mb-4">Pagos en revisión</h1>
      </v-flex>
    </v-layout>

    <v-card>
      <v-card-text class="pa-0">
        <v-data-table
          :headers="headers"
          :items="pagos"
          :loading="loading"
          :pagination.sync="pagination"
          :total-items="totalItems"
          hide-actions
          class="elevation-0"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                <span v-if="props.item.personas && props.item.personas[0]">
                  {{ props.item.personas[0].nombre || "Sin nombre" }},
                  {{ props.item.personas[0].apellido || "Sin apellido" }}
                </span>
                <span v-else>Sin datos del participante</span>
              </td>
              <td class="text-xs-center">
                <v-chip
                  :color="getEstadoColor(props.item.state)"
                  text-color="white"
                  small
                >
                  {{ getEstadoLabel(props.item.state) }}
                </v-chip>
              </td>
              <td class="text-xs-center hidden-sm-and-down">
                {{ formatPaymentDate(props.item.payment_receipt_uploaded_at) }}
              </td>
              <td class="text-xs-center">
                <span v-if="props.item.modalidad && props.item.modalidad.evento">
                  {{ props.item.modalidad.evento.nombre }}
                </span>
                <span v-else>—</span>
              </td>
              <td class="text-xs-center">
                <v-btn
                  @click.stop="abrirMarcarPagada(props.item)"
                  color="green"
                  small
                  outlined
                >
                  <v-icon left small>attach_money</v-icon>
                  Marcar pagada
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-alert :value="true" type="info" class="ma-4">
              No hay pagos para mostrar.
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-pagination
          v-model="pagination.page"
          :length="totalPages"
          :total-visible="7"
          @input="onPageChange"
        ></v-pagination>
      </v-card-actions>
    </v-card>

    <MarcarPagadaDialog
      ref="dialogMarcarPagada"
      :inscripcion="inscripcionEditar"
      @refrescarDatos="fetchPagos"
    />
  </v-container>
</template>

<script>
import Vuex from "vuex";
import api from "@/api/inscripcion";
import moment from "moment";
import MarcarPagadaDialog from "@/components/inscripcion/inscripcion-pagada/MarcarPagadaDialog.vue";

export default {
  name: "PagosLista",
  components: {
    MarcarPagadaDialog,
  },
  data() {
    return {
      pagos: [],
      loading: false,
      inscripcionEditar: {},
      pagination: {
        page: 1,
        rowsPerPage: 20,
      },
      totalItems: 0,
      headers: [
        { text: "Participante", sortable: false },
        { text: "Estado", sortable: false },
        { text: "Fecha subida", sortable: false, class: "hidden-sm-and-down" },
        { text: "Evento", sortable: false },
        { text: "Acción", sortable: false },
      ],
    };
  },
  computed: {
    ...Vuex.mapGetters("auth", ["isAdmin"]),
    totalPages() {
      if (this.pagination.rowsPerPage <= 0) return 1;
      return Math.ceil(this.totalItems / this.pagination.rowsPerPage) || 1;
    },
  },
  mounted() {
    this.fetchPagos();
  },
  methods: {
    formatPaymentDate(date) {
      if (!date) return "Sin fecha";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    getEstadoColor(estado) {
      const colores = {
        pago_realizado: "success",
        pago_en_revision: "warning",
        pago_rechazado: "error",
        pago_pendiente: "info",
      };
      return colores[estado] || "grey";
    },
    getEstadoLabel(estado) {
      const labels = {
        pago_realizado: "Aprobado",
        pago_en_revision: "En revisión",
        pago_rechazado: "Rechazado",
        pago_pendiente: "Pendiente",
      };
      return labels[estado] || estado || "Sin estado";
    },
    abrirMarcarPagada(inscripcion) {
      this.inscripcionEditar = JSON.parse(JSON.stringify(inscripcion));
      this.$refs.dialogMarcarPagada.abrirDialog();
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.fetchPagos();
    },
    fetchPagos() {
      this.loading = true;
      api
        .getPayments({
          page: this.pagination.page,
          per_page: this.pagination.rowsPerPage,
          estado: "pago_en_revision",
          sort_by: "payment_receipt_uploaded_at",
          sort_desc: true,
        })
        .then((res) => {
          if (!res) {
            this.pagos = [];
            this.totalItems = 0;
            return;
          }
          if (Array.isArray(res)) {
            this.pagos = res;
            this.totalItems = res.length;
          } else {
            this.pagos = res.data || [];
            this.totalItems = res.total || 0;
          }
        })
        .catch(() => {
          this.pagos = [];
          this.totalItems = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
